import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';
import { SelfOnboardingActor } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.actor}selfonboarding/actor`;

interface UpsertSelfOnboardingActorCommandPayload {
  payload: SelfOnboardingActor;
}

async function upsertSelfOnboardingActorCommand({
  payload,
}: UpsertSelfOnboardingActorCommandPayload): Promise<
  BaseBackResponse | BackResponseFailure
> {
  try {
    const response = await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.PUT,
      json: payload,
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default upsertSelfOnboardingActorCommand;
